// NPM Imports
import React from "react";

// Component Imports
import AttachmentComponent from "./AttachmentComponent";
import AttachmentComponentUpgrade from "./AttachmentComponentUpgrade";
import { FeatureGating } from "../../commonComponents";

// Internal Imports
import { FEATURES } from "../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function (props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.DOCUMENT_ATTACHMENT}
      altComponent={
        <AttachmentComponentUpgrade
          {...props}
          featureName={FEATURES_NAME.DOCUMENT_ATTACHMENT}
        />
      }>
      <AttachmentComponent {...props} />
    </FeatureGating>
  );
}
